import {useEffect, useState} from "react";
import {REVIEW_LABELS} from "./reviewStatus";

// The search is answered by the server over every page of the submission, so it is the way to find
// a recording by the name the device gave it - the browser's own find only sees the page in front
// of you. Typing is debounced because each keystroke would otherwise cost two queries.
export default function Filters({filters, setFilters}) {
	const [search, setSearch] = useState(filters.search || "");

	useEffect(() => {
		if (search === filters.search) {
			return;
		}
		const timeout = setTimeout(() => {
			setFilters(prev => {
				return {
					...prev,
					search
				};
			});
		}, 300);

		return () => clearTimeout(timeout);
	}, [search, filters.search, setFilters]);

	return (
		<div className={"mb-2 row g-2 mx-0"}>
			<div className={"col-5 col-md-2"}>
				<input type="number" placeholder={"Id #"} className={"form-control"} value={filters.id} onChange={(e) => setFilters(prev => {
					return {
						...prev,
						id: e.target.value
					};
				})}/>
			</div>
			<div className={"col-7 col-md-2"}>
				<select className={"form-select"} value={filters.qaFilter} onChange={evt => {
					setFilters(prev => {
						return {
							...prev,
							qaFilter: evt.target.value
						};
					});
				}}>
					<option value="">All</option>
					<option value="warning">Warnings only</option>
					<option value="rejected">Rejected only</option>
					<option value="approved">Approved</option>
				</select>
			</div>
			<div className={"col-12 col-md-3"}>
				<select className={"form-select"} value={filters.reviewFilter} onChange={evt => {
					setFilters(prev => {
						return {
							...prev,
							reviewFilter: evt.target.value
						};
					});
				}}>
					<option value="">All review statuses</option>
					<option value="pending">{REVIEW_LABELS.pending}</option>
					<option value="accepted">{REVIEW_LABELS.accepted}</option>
					<option value="approved">{REVIEW_LABELS.approved}</option>
					<option value="rejected">{REVIEW_LABELS.rejected}</option>
					<option value="needsRework">{REVIEW_LABELS.needsRework}</option>
					<option value="resubmitted">{REVIEW_LABELS.resubmitted}</option>
				</select>
			</div>
			<div className={"col-12 col-md-5"}>
				<input type="text" className={"form-control"} value={search}
					   placeholder="Search a file name or any answer - 2026_09_07_11_29_41_973.mov"
					   onChange={(e) => setSearch(e.target.value)}/>
			</div>
		</div>
	);
}
